import assert from '@/sui/tools/assert'

import { goFieldsToJS, goTreeToJS } from '@/sui/data/sheets/edit/fromGo'
import notes from '@/sui/data/sheets/edit/notes/common'
import tools from '@/sui/data/sheets/edit/tools'
import ice from '@/sui/tools/ice'
import go from '@/gojs/go'

function addOptions (field, optional, displayOptions) {
  assert(field.type === 'pickList')
  field.config.optional = optional
  field.config.display = displayOptions
}

const data = go.toolsUsage.v2026
assert.notNull(data, `No tools usage GOJS module data found for 2026`)

const fields = goFieldsToJS(data.fields)
assert.notNull(fields, `No tools usage fields found for 2026`)

addOptions(
  fields.resultsUsage, true, {
    layout: { xs: 1, sm: 2, md: 3 }
  }
)

addOptions(
  fields.nationalResultsUsage, true, {
    layout: { xs: 1, sm: 2, md: 3 }
  }
)

addOptions(
  fields.techSheetsUsage, true, {
    layout: { xs: 1, sm: 3 },
    imgDirectory: 'sui/assets/img/toolsUsage/techSheets'
  }
)

addOptions(
  fields.educationalToolsUsage, true, {
    layout: { xs: 1, md: 2 },
    imgDirectory: 'sui/assets/img/toolsUsage/educationalTools'
  }
)

addOptions(
  fields.actuThemesUsage, true, {
    layout: { xs: 1, sm: 2, md: 3 }
  }
)

addOptions(
  fields.trainingToolsUsage, true, {
    layout: { xs: 1, sm: 3 },
    imgDirectory: 'sui/assets/img/toolsUsage/trainingTools'
  }
)

const titles = {
  trainingCourses: {
    text: 'SESSIONS DE FORMATIONS ORGANISÉES ENTRE LE 15 JUILLET 2025 ET LE 15 JUILLET 2026',
    start: fields.trainingCourses.field,
    type: 'results'
  },

  toolsUsage: {
    text: 'OUTILS SPIADI UTILISÉS DIRECTEMENT OU INDIRECTEMENT DANS VOS SESSIONS DE FORMATION',
    start: fields.usedSpiadiContents.field,
    hiddenWhenFieldIgnored: true,
    type: 'results'
  },

  otherToolsUsage: {
    text: 'AUTRE OUTILS',
    start: fields.usedOtherTools.field,
    hiddenWhenFieldIgnored: true,
    type: 'dark-primary'
  }
}

tools.addMultiline([ fields.otherTools ])

function checkToolsUsage (result, sheet, year) {
  assert.notNull(result)
  assert.notNull(sheet)
  assert.isNumber(year)

  const spiadi = sheet[fields.usedSpiadiContents.field]
  if (spiadi !== 1) {
    return
  }

  const f = [
    fields.resultsUsage.field,
    fields.techSheetsUsage.field,
    fields.educationalToolsUsage.field,
    fields.actuThemesUsage.field,
    fields.trainingToolsUsage.field
  ]

  if (notes.checkPickList.atLeastOne(sheet, f)) {
    return
  }

  const usedOtherTools = sheet[fields.usedOtherTools.field]
  const otherTools = sheet[fields.otherTools.field]
  if (usedOtherTools === 1 && otherTools != null && otherTools !== '') {
    return
  }

  const note = result[fields.usedSpiadiContents.field]
  note.type = 'error'
  note.tooltip =
      `Vous devez sélectionner au moins un outil ci-dessous (fiche technique, outil pédagogique ou de formation)`
}

function checkNonZeroIntFields (result, sheet, year) {
  assert.notNull(result)
  assert.notNull(sheet)
  assert.isNumber(year)

  const nonZeroIntFields = [
    {
      field: fields.sessionCount.field,
      text: 'sessions de formation'
    },
    {
      field: fields.attendeeCount.field,
      text: 'professionnels formés'
    }
  ]

  for (let i = 0; i < nonZeroIntFields.length; i++) {
    const f = nonZeroIntFields[i]
    const value = parseInt(sheet[f.field])

    if (value == null || value !== 0) {
      continue
    }

    const note = result[f.field]
    note.type = 'error'
    note.tooltip = `Le nombre de ${f.text} ne peut pas être égal à zéro`
  }
}

function buildNotes2026 (result, sheet, surveillance) {
  checkNonZeroIntFields(result, sheet, 2026)
  checkToolsUsage(result, sheet, 2026)

  return result
}

const sheet = {
  titles: [
    titles.trainingCourses,
    titles.toolsUsage,
    titles.otherToolsUsage
  ],

  repeatableTitles: [],

  fields: goTreeToJS(
    data.tree, fields
  ),

  buildNotes: buildNotes2026
}

const result = {
  fields,
  titles,
  sheet
}

export default ice.freeze(result, 10)
